import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const __default__ = {
  name: 'whitelistManage'
};
import WhiteTableBlock from "@/views/payManage/whitelistManage/components/WhiteTableBlock.vue";
import WhiteFilterBlock from "@/views/payManage/whitelistManage/components/WhiteFilterBlock.vue";
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const tableRef = ref(null);
    const filterRef = ref(null);
    const filterSubmit = obj => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(obj);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(WhiteFilterBlock, {
        ref_key: "filterRef",
        ref: filterRef,
        onFilterSubmit: filterSubmit
      }, null, 512), _createVNode(WhiteTableBlock, {
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512)]);
    };
  }
});